import styled from "styled-components";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { SectionTitle } from "../components/SectionTitle";
import { PrimaryButton } from "../components/Buttons";

export const MentoringSection = () => {
  return (
    <MentoringWrapper>
      <MentoringContainer>
        <SectionTitle title="Mentoring" centered />
        <br />
        <BodyText>
          Power Dynamics is in everything around us. Whether we are aware of it
          or not. Whether we like it or not. Whether we consent to it or not.
          For the last decade I have not only studied such dynamics, but also
          yielded them consciously. From the dungeon to the boardroom. From the
          intricacies of my most vulnerable inner workings, to the structural
          pillars of our society.
        </BodyText>
        <BodyText>
          I have built a Professional Domination practice from the ground up,
          expanded it overseas, studied it and applied it consciously. Beyond
          the kinky world, I have thrived in a career in male-dominated fields
          and explored love and eroticism in non-normative paths. When I sit
          across from you in a mentoring session, I'm not telling you what to do
          or where to go. I'm giving you a map, and tools to find the voice
          within yourself that will tell you where to go next.
        </BodyText>
        <BodyText>
          Whether you are learning to hold a flogger or hold a room - I have
          been there. And I'll tell you where the traps, pitfalls are - but also
          the most beautiful views and treasures. So that you can be exactly
          where you'd reach anyway. But with less unnecessary scars. And more
          pleasure.
        </BodyText>

        <br />
        <br />
        <ButtonRow>
          <Link to="/mentoring">
            <PrimaryButton>Explore Mentoring</PrimaryButton>
          </Link>
        </ButtonRow>
        <br />
      </MentoringContainer>
    </MentoringWrapper>
  );
};

const MentoringWrapper = styled.div`
  min-height: 75vh;
  margin: 0 auto;

  @media screen and (max-width: 500px) {
    display: flex;
    padding: 4rem 1rem;
    justify-content: center;
  }
`;

const MentoringContainer = styled.div`
  margin: 4rem 4.1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: rgba(10, 10, 10, 0.82);
  padding: 4rem;
  border-radius: 16px;

  @media screen and (max-width: 600px) {
    padding: 2rem 1rem;
    margin: 0 auto;
    width: 100%;
    min-height: 100vh;
  }
`;

const BodyText = styled.p`
  font-size: 18px;
  line-height: 2;
  font-family: "Ysabeau", sans-serif;
  color: rgba(239, 233, 225, 0.8);
  text-align: center;

  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 1.7;
    padding: 0 0.5rem;
  }
`;

const ButtonRow = styled.div`
  margin-top: 2.5rem;
`;
